import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import AppointmentPage from "./pages/AppointmentsPage";
import StaffPage from "./pages/StaffPage";
import AddAppointmentPage from "./pages/AddAppointmentPage";
import AddStaffPage from "./pages/AddStaffPage";
import AddStockPage from "./pages/AddStockPage";
import ViewAppointmentPage from "./pages/ViewAppointmentPage";
import EditAppointmentPage from "./pages/EditAppointmentPage";
import AssignAppointmentPage from "./pages/AssignAppointmentPage";
import StockListPage from "./pages/StockListPage";
import ViewStockPage from "./pages/ViewStockPage";
import EditStockPage from "./pages/EditStockPage";
import CustomerPage from "./pages/CustomerPage";
import AppointmentStatusPage from "./pages/AppointmentStatusPage";
import AddCompanyPage from "./components/AddCompanyPage";
import ViewCustomerPage from "./components/ViewCustomerPage";
import EditCustomerPage from "./components/EditCustomerPage";
import ViewStaffPage from "./components/ViewStaffPage";
import InvoiceListStatusPage from "./pages/InvoiceListStatusPage";
import QuoteAddPage from "./pages/QuoteAddPage";
import QuoteListPage from "./pages/QuoteListPage";
import QuoteEditPage from "./pages/QuoteEditPage";
import QuotePreviewPage from "./pages/QuotePreviewPage";
import AddPolicyPage from "./components/AddPolicyPage";
import EditPolicyPage from "./components/EditPolicyPage";
import AddServicePage from "./pages/AddServicePage";
import ServiceListPage from "./pages/ServiceListPage";
import ViewServicePage from "./pages/ViewServicePage";
import EditServicePage from "./pages/EditServicePage";
import JobInvoicePreviewPage from "./pages/JobInvoicePreviewPage";
import AddWorkForcePage from "./pages/AddWorkForcePage";
import WorkForcePage from "./pages/WorkForcePage";
import EditAddWorkForcePage from "./pages/EditAddWorkForcePage";
import ViewWorkForcePage from "./pages/ViewWorkForcePage";
import ShowReportPage from "./components/ShowReportPage";
import JobInvoicePage from "./pages/JobInvoicePage";
import AdminTimesheetPage from "./pages/AdminTimesheetPage";
import AdminOvertimePage from "./pages/AdminOvertimePage";
import { useEffect } from "react";


function App() {
  // useEffect(() => {
  //   // Example: Zoom out to 90% on load
  //   document.documentElement.style.transform = 'scale(1)';
  //   document.documentElement.style.transformOrigin = 'top left';
  //   document.documentElement.style.width = '100%'; // 100 / 0.9
  //   document.documentElement.style.height = '111.11%';
    
  //   // Optional: adjust on resize
  //   const handleResize = () => {
  //     const scale = window.innerWidth < 768 ? 0.8 : 0.9;
  //     document.documentElement.style.transform = `scale(${scale})`;
  //     document.documentElement.style.width = `${100 / scale}%`;
  //     document.documentElement.style.height = `${100 / scale}%`;
  //   };
    
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route exact path="/" element={<HomePageTwo/>} />
        <Route exact path="/jobs" element={<AppointmentPage/>} />
        <Route exact path="/add-job" element={<AddAppointmentPage/>} />
        <Route exact path="/jobs/:status" element={<AppointmentStatusPage/>} />
        {/* <Route exact path="/create-job-invoice/:id" element={<JobInvoicePage/>} />*/}
        <Route exact path="/jobs/invoices/:id" element={<JobInvoicePage/>} /> 
        <Route exact path="/jobs/view/:id" element={<ViewAppointmentPage/>} />
        <Route exact path="/jobs/edit/:id" element={<EditAppointmentPage/>} />
        <Route exact path="/jobs/view/invoices/:job_id" element={<JobInvoicePreviewPage/>} />
        <Route exact path="/jobs/report/:id" element={<ShowReportPage/>} />
        <Route exact path="/assign-job" element={<AssignAppointmentPage/>} />
        {/* <Route exact path="/view-invoice-job/:job_id" element={<JobInvoicePreviewPage/>} /> */}
        <Route exact path="/add-staff" element={<AddStaffPage/>} />
        <Route exact path="/staff" element={<StaffPage/>} />
        <Route exact path="/staff/:id" element={<ViewStaffPage/>} />
        <Route exact path="/customers" element={<CustomerPage/>} />
        <Route exact path="/customers/view/:id" element={<ViewCustomerPage/>} />
        <Route exact path="/customers/edit/:id" element={<EditCustomerPage/>} />
        <Route exact path="/add-service" element={<AddServicePage/>} />
        <Route exact path="/services" element={<ServiceListPage/>} />
        <Route exact path="/services/view/:id" element={<ViewServicePage/>} />
        <Route exact path="/services/edit/:id" element={<EditServicePage/>} />
        <Route exact path="/add-stock" element={<AddStockPage/>} />
        <Route exact path="/stock" element={<StockListPage/>} />
        <Route exact path="/stock/view/:id" element={<ViewStockPage/>} />
        <Route exact path="/stock/edit/:id" element={<EditStockPage/>} />
        <Route exact path="/company" element={<AddCompanyPage/>} />
        <Route exact path="/add-workforce" element={<AddWorkForcePage/>} />
        <Route exact path="/workforce" element={<WorkForcePage/>} />
        <Route exact path="/workforce/view/:id" element={<ViewWorkForcePage/>} />
        <Route exact path="/workforce/edit/:id" element={<EditAddWorkForcePage/>} />
        <Route exact path="/timesheet" element={<AdminTimesheetPage/>} />
        <Route exact path="/overtime" element={<AdminOvertimePage/>} />
        <Route exact path="/invoices" element={<InvoiceListPage />} />
        <Route exact path="/create-invoice" element={<InvoiceAddPage />} />
        <Route exact path="/invoices/:status" element={<InvoiceListStatusPage />} />
        <Route exact path="/invoices/edit/:id" element={<InvoiceEditPage />} />
        <Route exact path="/invoices/preview/:id" element={<InvoicePreviewPage />} />
        <Route exact path="/create-quote" element={<QuoteAddPage />} />
        <Route exact path="/quotes" element={<QuoteListPage />} />
        <Route exact path="/quotes/edit/:id" element={<QuoteEditPage />} />
        <Route exact path="/quotes/preview/:id" element={<QuotePreviewPage />} />
        <Route exact path="/policies" element={<AddPolicyPage />} />
        <Route exact path="/policies/edit/:id" element={<EditPolicyPage />} />
      
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/alert" element={<AlertPage />} />
        <Route exact path="/assign-role" element={<AssignRolePage />} />
        <Route exact path="/avatar" element={<AvatarPage />} />
        <Route exact path="/badges" element={<BadgesPage />} />
        <Route exact path="/button" element={<ButtonPage />} />
        <Route exact path="/calendar-main" element={<CalendarMainPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/card" element={<CardPage />} />
        <Route exact path="/carousel" element={<CarouselPage />} />
        <Route exact path="/chat-empty" element={<ChatEmptyPage />} />
        <Route exact path="/electrician-chat" element={<ChatMessagePage />} />
        <Route exact path="/chat-profile" element={<ChatProfilePage />} />
        <Route exact path="/code-generator" element={<CodeGeneratorPage />} />
        <Route exact path="/code-generator-new" element={<CodeGeneratorNewPage />} />
        <Route exact path="/colors" element={<ColorsPage />} />
        <Route exact path="/column-chart" element={<ColumnChartPage />} />
        <Route exact path="/company" element={<CompanyPage />} />
        <Route exact path="/currencies" element={<CurrenciesPage />} />
        <Route exact path="/dropdown" element={<DropdownPage />} />
        <Route exact path="/email" element={<EmailPage />} />
        <Route exact path="/faq" element={<FaqPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/form-layout" element={<FormLayoutPage />} />
        <Route exact path="/form-validation" element={<FormValidationPage />} />
        <Route exact path="/form" element={<FormPage />} />
        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/image-generator" element={<ImageGeneratorPage />} />
        <Route exact path="/image-upload" element={<ImageUploadPage />} />
   
        <Route exact path="/kanban" element={<KanbanPage />} />
        <Route exact path="/language" element={<LanguagePage />} />
        <Route exact path="/line-chart" element={<LineChartPage />} />
        <Route exact path="/list" element={<ListPage />} />
        <Route exact path="/marketplace-details" element={<MarketplaceDetailsPage />} />
        <Route exact path="/marketplace" element={<MarketplacePage />} />
        <Route exact path="/notification-alert" element={<NotificationAlertPage />} />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        <Route exact path="/terms-condition" element={<TermsConditionPage />} />
        <Route exact path="/text-generator-new" element={<TextGeneratorNewPage />} />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route exact path="/wallet" element={<WalletPage />} />
        <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} />


        <Route exact path="*" element={<ErrorPage />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;



